import { render } from "./KindUploadListComponent.vue?vue&type=template&id=6b3bfbd8"
import script from "./KindUploadListComponent.vue?vue&type=script&lang=js"
export * from "./KindUploadListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__